import React from 'react';
import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  backgroundColor,
  borderColor,
  borderRadius,
  borderStyle,
  borderWidth,
  display,
  flex,
  overflow,
  position,
  themeGet,
  zIndex,
} from 'styled-system';
import type {
  BackgroundColorProps,
  BorderColorProps,
  BorderProps,
  BorderRadiusProps,
  BorderStyleProps,
  BorderWidthProps,
  DisplayProps,
  FlexProps,
  OverflowProps,
  PositionProps,
  SpaceProps,
} from 'styled-system';

import type { TransitionPropertyProps } from '../../theme/system-utilities';
import { transitionProperty } from '../../theme/system-utilities';

const UnstyledSearchInputBorder = styled.div<
  DisplayProps &
    BorderColorProps &
    BorderStyleProps &
    BorderWidthProps &
    OverflowProps &
    BackgroundColorProps &
    PositionProps &
    BorderProps &
    BorderRadiusProps &
    FlexProps &
    TransitionPropertyProps &
    SpaceProps & {
      locked: boolean;
      timeout: number;
      focused: boolean;
    }
>`
  ${display};
  ${flex};
  ${position};
  ${zIndex};
  ${overflow};
  ${backgroundColor};
  ${transitionProperty};
  ${borderColor};
  ${borderRadius};
  ${borderStyle};
  ${borderWidth};

  &:hover,
  &:focus {
    border-color: ${themeGet('colors.sys.neutral.border.strong')};
  }

  ${props => {
    const { locked, timeout } = props;

    return css`
      margin-left: ${locked
        ? themeGet('space.sp_0')(props)
        : `-${themeGet('space.sp_40')(props)}px`};
      transition-duration: ${timeout}ms;
      ${locked
        ? css`
            transition-timing-function: ease-out;
            transition-delay: ${timeout}ms;
          `
        : css`
            transition-timing-function: ease-in;
          `};
    `;
  }}
`;

const SearchInputBorder = (props: ComponentProps<typeof UnstyledSearchInputBorder>) => (
  <UnstyledSearchInputBorder
    overflow="hidden"
    backgroundColor="sys.neutral.background.weak"
    transitionProperty="margin-left"
    position="relative"
    display="flex"
    flex="1 1 auto"
    borderColor="sys.neutral.border.default"
    borderRadius="x-large"
    borderStyle="solid"
    borderWidth={1}
    {...props}
  />
);

export default SearchInputBorder;
